<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="isBusy"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="Owner" v-if="canSelectUser" prop="user_id">
        <el-select
          v-model="form.user_id"
          class="w-100"
          filterable
          @input="onUserSelected"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.full_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Brand" prop="brand_id">
        <el-select v-model="form.brand_id" class="w-100" :disabled="isEditMode">
          <el-option
            v-for="item in brands"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Expiry period" prop="expiry_period">
        <el-input-number
          v-model="form.expiry_period"
          :precision="0"
          :min="1"
        ></el-input-number>
        <p>Contacts expire from this group in X days</p>
      </el-form-item>
      <button class="btn btn-purple px-4 mt-5" @click.prevent="store">Store</button>
    </el-form>
  </div>
</template>

<script>
import BaseForm from "../../form.vue";

export default {
  extends: BaseForm,

  props: {
    canSelectUser: Boolean,
    users: Array,
    storeUrl: String,
  },

  data() {
    const form = {
      user_id: null,
      brand_id: null,
      name: null,
      expiry_period: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      loading: false,
    };
  },

  computed: {
    /**
     * @return {Object|null}
     */
    selectedUser() {
      return _.find(this.users, {id: this.form.user_id}) || null;
    },

    /**
     * @return {Array}
     */
    brands() {
      return _.get(this.selectedUser, 'brands', []);
    },
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = {
        user_id: _.get(model, 'user_id', null),
        brand_id: _.get(model, 'brand_id', null),
        name: _.get(model, 'name', null),
        expiry_period: this.secondsToHours(model.expiry_period),
      };
    },

    /**
     * @return {Object}
     */
    getForm() {
      return  _.assign({}, _.omit(this.form, ['expiry_period']), {
        expiry_period: this.hoursToSeconds(this.form.expiry_period),
        _method: this.method,
      });
    },

    /**
     * @param {*} value
     * @return {number|null}
     */
    secondsToHours(value) {
      if (_.isNull(value) || _.isUndefined(value)) {
        return undefined;
      }

      return _.ceil(Number(value) / (60 * 60 * 24));
    },

    /**
     * @param {*} value
     * @return {number|null}
     */
    hoursToSeconds(value) {
      if (_.isNull(value) || _.isUndefined(value)) {
        return null;
      }

      return _.ceil(Number(value)) * (60 * 60 * 24);
    },

    /**
     * @return {undefined}
     */
    onUserSelected() {
      const hasCurrentBrand = _.find(this.brands, {id: this.form.brand_id});
      if (!hasCurrentBrand) {
        this.form.brand_id = null;
      }
    },

    /**
     * @param {Object} res
     * @return {boolean}
     */
    storeSuccess({data: {model, message}}) {
      _.isString(message) && this.$message.success(message);
      this.$emit('stored', model);
    },
  },
}
</script>

<style scoped>

</style>
